module.exports = {
      id: "authorwhite-usage",
      viewBox: "0 0 30.127 24.506",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#authorwhite",
      toString: function () {
        return this.url;
      }
    }